/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_New_DayInputs */

const en_us2_plan_build_new_day = /** @type {(inputs: Plan_Build_New_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New workout`)
};

const pt_br2_plan_build_new_day = /** @type {(inputs: Plan_Build_New_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo treino`)
};

const es_419_plan_build_new_day = /** @type {(inputs: Plan_Build_New_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo entrenamiento`)
};

const pt_pt2_plan_build_new_day = /** @type {(inputs: Plan_Build_New_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo treino`)
};

const fr_fr2_plan_build_new_day = /** @type {(inputs: Plan_Build_New_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle séance`)
};

const de_de2_plan_build_new_day = /** @type {(inputs: Plan_Build_New_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Training`)
};

const it_it2_plan_build_new_day = /** @type {(inputs: Plan_Build_New_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo allenamento`)
};

/**
* | output |
* | --- |
* | "New workout" |
*
* @param {Plan_Build_New_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_new_day = /** @type {((inputs?: Plan_Build_New_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_New_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_new_day(inputs)
	if (locale === "es-419") return es_419_plan_build_new_day(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_new_day(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_new_day(inputs)
	if (locale === "de-DE") return de_de2_plan_build_new_day(inputs)
	if (locale === "it-IT") return it_it2_plan_build_new_day(inputs)
	return en_us2_plan_build_new_day(inputs)
});
export { plan_build_new_day as "plan-build.new_day" }